<template>
    <div>
        <div class="step-title step-2 d-flex flex-row">
            <img alt="" class="mr-3 mb-3" :height="fields?.products_quantity_icon ? 20 : 0"
                :src="fields?.products_quantity_icon ? fields?.products_quantity_icon : ''" srcset=""
                :width="fields?.products_quantity_icon ? 20 : 0" />
            <h2 class="title" v-text="fields?.tr_quantity"></h2>
        </div>
        <div id="js-widget-products" class="product-list">
            <div v-for="(product, index) in products" v-bind:key="product.id"
                v-bind:class="[index === activeProduct ? 'product-list-item active' : 'product-list-item']"
                v-on:click="changeActiveProduct(index, product)" :id="'prod_' + index">
                <div class="product-list-item--header">
                    <p class="">{{ product.amount }}x {{ product.display_name }}</p>
                    <div class="save" :style="returnStyles()">
                        {{ fields.tr_checkout_save }} {{ product.you_save_percentage }}%
                    </div>
                    <div v-if="product.best_seller" class="best-seller d-flex align-items-center">
                        <img height="12" width="12" :src="fields.star_icon" srcset="" /><span>{{
                            product.status
                        }}</span>
                    </div>
                    <span class="fast-delivery d-none d-md-block"><img alt="" width="20" height="20"
                            :src="fields.shipping_truck_icon" srcset="" />
                        <span>{{ fields.tr_fast_delivery_text }}</span></span>
                </div>
                <div class="w_radio">
                    <input :id="'prod_' + index" name="product" type="radio" v-bind:checked="index === activeProduct"
                        value="699" />
                    <i class="icon-check"></i>
                    <div class="product-item--inner">
                        <div class="prod-image">
                            <picture>
                                <source media="(max-width:678px)" :srcset="returnAmount()" :type="returnType()"
                                    :alt="returnAlt()" />
                                <source media="(min-width:679px)" :srcset="product.image.url"
                                    :type="product.image.mime_type" :alt="product.display_name" />
                                <img :srcset="product.image.url" :type="product.image.mime_type"
                                    :alt="product.display_name" />
                            </picture>

                            <div class="product-amount d-block d-md-none">x{{ product.amount }}</div>
                        </div>
                        <div class="product-desc">
                            <div class="price" v-bind:class="{ smaller: product.price > 1000 || currencyCode == 'MXN' }">
                                <span notranslate>
                                    {{ product.formatted_price ? product.formatted_price : $filters.money(product.price, currencyLocale, currencyCode !== undefined ? currencyCode : '') }}
                                </span><span class="each">/{{ fields.tr_each_text }}</span>
                            </div>
                            <div class="orig">
                                {{ fields.tr_orig_text }}
                                {{ product.formatted_old_price ? product.formatted_old_price : $filters.money(product.old_price, currencyLocale, currencyCode) }}
                            </div>
                            <div v-if="product.show_additional_text_info" class="space" v-html="product.tr_additional_texts"></div>
                            <div v-if="product.shipping_price > 0" class="total-price">
                                <span>{{ fields.tr_total_price }}:</span><span notranslate>
                                {{ product.formatted_total_amount ? product.formatted_total_amount : $filters.money(product.price * product.amount, currencyLocale, currencyCode) }}</span>
                            </div>
                            <div v-else class="total-price total-free-shipping" :class="{'additional-text' : product.show_additional_text_info}">
                                + {{ fields.tr_free_shipping }}
                            </div>
                        </div>
                    </div>
                </div>

                <VariantsPicker
                    v-if="activeProduct === index && productData.enable_variants"
                    :variants="productData.variants" :activeProduct="activeProduct" :current="index" />

                <div class="product-list-item--bottombar">
                    <div class="product-list-item--bottombar--inner">
                        <div class="risk">
                            {{ fields.tr_sell_out_risk }}: <span>{{ fields.tr_sell_out_risk_status_text }}</span>
                        </div>
                        <div class="shipping">{{ fields.tr_fast_delivery_text }}</div>
                        <div class="discount d-none d-md-block">
                            {{ fields.tr_discount_text }}: {{ product.you_save_percentage }}%
                        </div>
                        <div class="popular">
                            <img alt="" width="10" height="10" :src="fields.signal_bars_icon" />
                            {{ product.status }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue'
import { useCartStore } from '../state/cart'
import VariantsPicker from "./VariantsPicker.vue";
import SmoothScroll from 'smooth-scroll';

const fields = window.msg
const products = window.products
const productData = window.productData
const currencyCode = productData?.currency_code;
const currencyLocale = window.locale;

const activeProduct = ref(null)

const cart = useCartStore()

cart.$patch({
    currencyCode: currencyCode,
    campaignId: productData?.konnektive_campaign_id,
    paypalEnabled: productData?.paypal_enabled
})

function returnStyles() {
    let country = 'EU'
    let additionalStyles = ''
    if (country === 'FR') {
        additionalStyles = 'padding: 2px 3px; font-size: 13px; margin: 0 5px; line-height: 18px;'
    }
    return additionalStyles
}

function returnAmount() {
    return Object.values(products).filter((product) => product.amount == 1)[0].image.url;
}

function returnType() {
    return Object.values(products).filter((product) => product.amount == 1)[0].image.mime_type;
}

function returnAlt() {
    return Object.values(products).filter((product) => product.amount == 1)[0].image.display_name;
}

const changeActiveProduct = (index, product) => {
  const initialSet = activeProduct.value === null;
  cart.changeActiveProduct(product, initialSet)
  
  
  activeProduct.value = index
  
  // Scroll to product on change (if not initial load)
  if (!initialSet && window.innerWidth < 768) {
    setTimeout(() => {
      const active = 'prod_' + index;
      var elmnt = document.getElementById(active);

      var scroll = new SmoothScroll('[data-easing="easeInOutQuad"]',
        {easing: 'easeInOutQuad', speed: 500, speedAsDuration: true, offset: 25});
      scroll.animateScroll(elmnt);

    }, 100);
  }
}

if (Array.isArray(products)) {
    products.forEach((product, index) => {
        if (product.best_seller) {
            changeActiveProduct(index, product)
        }
    })
} else {
    console.log('products is not an array:', products);
}

</script>

<style scoped>
.total-free-shipping {
    color: green;
    font-size: 14px !important;
    font-weight: 600 !important;
}

.w_radio {
    cursor: pointer;
}

@media screen and (max-width: 678px) {
    .w_radio {
        padding-left: 30px;
    }
}

@media screen and (min-width: 720px) {
    .smaller {
        font-size: 28px !important;
    }

    .total-free-shipping {
        font-size: 18px !important;
        font-weight: 600 !important;
    }

    .total-free-shipping.additional-text {
        font-size: 16px !important;
    }
}

.exitDiscount {
    width: 100%;
    display: block;
    background: #ff6d00;
    color: #fff;
    font-weight: bold;
    padding: 10px 10px;
    margin-bottom: 15px;
    border-radius: 5px;
    font-size: 16px;
}

.fast-delivery img {
    margin-right: 5px;
}

.save {
    line-height: 18px !important;
}

.product-list .product-item--inner .product-desc .space {
    line-height: 1.3;
    color: #01335e;
    font-size: 14px;
    font-weight: 600;
}
</style>
